/* =========================================================
   HORTIGO OS V92.2 — assets/hg-wallet.js
   Wallet module:
   - sync balance across app (wBal + hgTok)
   - render packages from HG.state.cfg.packages
   - click pack -> go to credit product / cart
   - redeem vouchers via HG.redeem()
   - reacts to hg:tokens-updated + hg:config-updated
========================================================= */

(() => {
  "use strict";

  function $(root, id) {
    return root ? root.querySelector(`#${CSS.escape(id)}`) : null;
  }

  function qsa(root, sel) {
    return Array.from(root ? root.querySelectorAll(sel) : []);
  }

  function bootWallet() {
    const HG = window.HG;
    if (!HG || !HG.state?.root) return;

    const root = HG.state.root;
    const iso = root.querySelector("#hg-iso");
    if (!iso) return;

    // prevent double bind
    if (root.getAttribute("data-hg-wallet-bound") === "1") return;
    root.setAttribute("data-hg-wallet-bound", "1");

    const wBal = $(root, "wBal");
    const tokTop = $(root, "hgTok");

    const packGrid = $(root, "packGrid");
    const pendWarn = $(root, "pendWarn");

    const vC = $(root, "vC");
    const btnRedeem = $(root, "btnRedeem");
    const vM = $(root, "vM");

    // BOOT config for credit product
    const bootCfg = HG.state.boot?.config || {};
    const creditUrl = String(bootCfg.creditUrl || "").trim(); // product url
    const creditId = Number(bootCfg.creditId || 0);          // variant id
    const premiumId = Number(bootCfg.premiumId || 0);

    function setText(el, t) {
      if (el) el.textContent = String(t ?? "");
    }

    function fmtTokens(n) {
      const v = Number.isFinite(+n) ? +n : 0;
      return String(v);
    }

    function renderBalance() {
      const tok = HG.state.user?.tok ?? 0;
      setText(wBal, fmtTokens(tok));
      setText(tokTop, fmtTokens(tok)); // keep topbar synced too
    }

    function renderPending() {
      if (!pendWarn) return;
      const pending = !!HG.state.user?.pending;
      pendWarn.classList.toggle("hidden", !pending);

      // If you want the button to go to premium cart
      const a = pendWarn.querySelector("a[href^='/cart/']");
      if (a && premiumId) a.setAttribute("href", `/cart/${premiumId}:1`);
    }

    function packToHref(pack) {
      // Prefer product page if present (so user can choose qty, see details)
      if (creditUrl) return creditUrl;

      // Fallback: direct add variant to cart (qty=1)
      if (creditId) return `/cart/${creditId}:1`;

      // last resort
      return "/cart";
    }

    function renderPackages() {
      if (!packGrid) return;

      const packs = Array.isArray(HG.state.cfg?.packages) ? HG.state.cfg.packages : [];
      if (!packs.length) {
        packGrid.innerHTML = `<div class="hg-empty">Nu există pachete în config.</div>`;
        return;
      }

      const href = packToHref();

      packGrid.innerHTML = packs.map((p, i) => {
        const credits = Number.isFinite(+p?.credits) ? +p.credits : 0;
        const text = String(p?.text || "").trim() || "Pachet";

        // UI label: “X Cr” + “text”
        const top = credits > 0 ? `${credits} Cr` : `Custom`;
        const small = credits > 0 ? text : "Introdu cantitate în produs";

        return `
          <a class="hg-pack" data-pack="${i}" href="${href}" style="text-decoration:none; color:inherit;">
            ${HG.ui.escapeHTML(top)}
            <small>${HG.ui.escapeHTML(small)}</small>
          </a>
        `;
      }).join("");

      // If you want “custom” to go to product page always:
      packGrid.querySelectorAll("[data-pack]").forEach((a) => {
        a.addEventListener("click", () => {
          // nothing special; using href
        });
      });
    }

    async function doRedeem() {
      if (!btnRedeem) return;

      const code = String(vC?.value || "").trim();
      if (!code) {
        if (vM) vM.textContent = "Introdu un cod.";
        return;
      }

      btnRedeem.disabled = true;
      if (vM) vM.textContent = "Se verifică…";

      try {
        const r = await HG.redeem(code);

        if (r && r.success) {
          const added = Number.isFinite(+r.added) ? +r.added : 0;
          if (vM) vM.textContent = `OK ✅ +${added} Cr (total ${HG.state.user.tok} Cr)`;
          if (vC) vC.value = "";
          // HG.redeem already emits hg:tokens-updated in core; but render anyway:
          renderBalance();
        } else {
          if (vM) vM.textContent = (r && r.message) ? String(r.message) : "Cod invalid.";
        }
      } catch (e) {
        if (vM) vM.textContent = "Eroare conexiune.";
      } finally {
        btnRedeem.disabled = false;
      }
    }

    function bind() {
      if (btnRedeem) btnRedeem.addEventListener("click", doRedeem);
      if (vC) vC.addEventListener("keydown", (e) => {
        if (e.key === "Enter") doRedeem();
      });

      // React to global updates
      document.addEventListener("hg:tokens-updated", () => {
        renderBalance();
        renderPending();
      });

      document.addEventListener("hg:config-updated", () => {
        renderPackages();
      });
    }

    function init() {
      renderBalance();
      renderPending();
      renderPackages();
      bind();
    }

    init();
  }

  function bootSafe() {
    if (window.HG?.state?.root) bootWallet();
  }

  // best: after HG is published
  document.addEventListener("hg:ready", () => {
    try { bootSafe(); } catch (_) {}
  });

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", bootSafe);
  } else {
    bootSafe();
  }

  document.addEventListener("shopify:section:load", () => {
    try { bootSafe(); } catch (_) {}
  });
})();
